import { consumablesService } from "Dashboard/scenes/Consumables/services/consumables.service";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { resourceMaintenanceTypeDictionary } from "utils/translationDictionary";

interface IMaintenanceTypeOption {
  label: string;
  value: string;
}

const ResourceMaintenanceTypeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IMaintenanceTypeOption[]>([]);
  const [value, setValue] = useState<IMaintenanceTypeOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const data = await consumablesService.getAllMaintenanceTypesForResources();
      const op = data.map((maintenanceType) => {
        return {
          label: resourceMaintenanceTypeDictionary[maintenanceType],
          value: maintenanceType,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  useEffect(() => {
    const values = options.filter((o) => o.value === props.value);
    if (values[0]) {
      setValue(values[0]);
    } else setValue(undefined);
  }, [options, props.value]);

  return (
    <Select
      isClearable
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
      {...{ error: props.error }}
    />
  );
});

export default ResourceMaintenanceTypeSelect;
